/* ============================================================================
   KODIAK SPORTS - PRE-ORDER CONSENT GATE
   File: assets/kodiak-preorder.js
   Pairs with: templates/page.preorder.liquid + assets/kodiak-preorder.css

   Responsibilities (kept narrow on purpose):
     1. Disable Add-to-Cart until the customer has read + agreed to the terms.
     2. Force the agreement through the modal (scroll-to-bottom -> "I Agree").
     3. Stamp the hidden line-item-property consent fields at agree-time.
     4. Revoke consent + clear fields if the checkbox is later unchecked.
     5. Update the displayed price on variant change.
     6. Final submit guard (fail closed).

   No external dependencies. Vanilla JS, loaded with defer.
   (c) 2026 Kodiak Sports, LLC.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('po-app');
  if (!root) { return; }

  var form       = document.getElementById('PreOrderForm');
  var submitBtn  = document.getElementById('po-submit');
  var agreeChk   = document.getElementById('po-agree');
  var openBtn    = document.getElementById('po-open-terms');
  var modal      = document.getElementById('po-modal');
  var modalBody  = document.getElementById('po-modal-body');
  var modalAgree = document.getElementById('po-modal-agree');
  var closeEls   = document.querySelectorAll('[data-po-close]');
  var variantSel = document.getElementById('po-variant');
  var priceOut   = document.getElementById('po-price');

  // Hidden consent fields (line-item properties)
  var fAck = document.getElementById('po-prop-ack');
  var fTs  = document.getElementById('po-prop-ts');
  var fUa  = document.getElementById('po-prop-ua');
  var fUrl = document.getElementById('po-prop-url');

  var ACK_TEXT = root.getAttribute('data-ack-text') || 'Pre-order terms accepted.';

  // consented = the customer completed the modal agree flow this session.
  var consented = false;

  /* ---------- state ---------- */
  function setSubmitState() {
    var ready = consented && agreeChk && agreeChk.checked;
    if (!submitBtn) { return; }
    submitBtn.disabled = !ready;
    submitBtn.textContent = ready
      ? (submitBtn.getAttribute('data-label-ready') || 'Pre-Order & Checkout')
      : (submitBtn.getAttribute('data-label-idle')  || 'Review Pre-Order Terms to Continue');
  }

  function recordConsent() {
    consented = true;
    if (fAck) { fAck.value = ACK_TEXT; }
    if (fTs)  { fTs.value  = new Date().toISOString(); }
    if (fUa)  { fUa.value  = (navigator && navigator.userAgent) || ''; }
    if (fUrl) { fUrl.value = window.location.href || ''; }
    if (agreeChk) { agreeChk.checked = true; }
    setSubmitState();
  }

  function clearConsent() {
    consented = false;
    if (fAck) { fAck.value = ''; }
    if (fTs)  { fTs.value  = ''; }
    if (fUa)  { fUa.value  = ''; }
    if (fUrl) { fUrl.value = ''; }
    setSubmitState();
  }

  /* ---------- modal ---------- */
  function openModal() {
    if (!modal) { return; }
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    checkScroll(); // re-evaluate the agree gate each open
    if (modalBody) { modalBody.focus(); }
  }

  function closeModal() {
    if (!modal) { return; }
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Enable the modal "I Agree" button only once the terms are scrolled to the end.
  function checkScroll() {
    if (!modalBody || !modalAgree) { return; }
    var threshold = 24; // px of slack at the bottom
    var atBottom = (modalBody.scrollTop + modalBody.clientHeight) >= (modalBody.scrollHeight - threshold);
    if (atBottom) {
      modalAgree.disabled = false;
      modalAgree.classList.remove('is-locked');
    }
  }

  /* ---------- price ---------- */
  function updatePrice() {
    if (!variantSel || !priceOut) { return; }
    var opt = variantSel.options[variantSel.selectedIndex];
    if (opt) { priceOut.textContent = opt.getAttribute('data-price') || ''; }
  }

  /* ---------- wire up ---------- */
  if (openBtn) {
    // The link lives inside the consent <label>; stop the click from also
    // toggling the checkbox via label propagation.
    openBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openModal(); });
    openBtn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); openModal(); }
    });
  }
  if (modalBody)  { modalBody.addEventListener('scroll', checkScroll); }
  if (modalAgree) { modalAgree.addEventListener('click', function () { recordConsent(); closeModal(); }); }
  if (variantSel) { variantSel.addEventListener('change', updatePrice); }

  Array.prototype.forEach.call(closeEls, function (el) {
    el.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) { closeModal(); }
  });

  // The box cannot be self-checked: any manual check routes through the modal.
  if (agreeChk) {
    agreeChk.addEventListener('change', function () {
      if (!agreeChk.checked) {
        clearConsent();
      } else if (!consented) {
        agreeChk.checked = false;
        openModal();
      } else {
        setSubmitState();
      }
    });
  }

  // Final guard: never submit without a live consent record.
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!(consented && agreeChk && agreeChk.checked)) {
        e.preventDefault();
        openModal();
      }
    });
  }

  // init
  updatePrice();
  setSubmitState();
})();